// https://github.com/fullstackreact/google-maps-react

import React, { Component } from 'react';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
import C from "../Const";

const mapStyles = {
    width: '100%',
    height: '100%'
};

export class StaticScenarioMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {},          //Shows the infoWindow to the selected place upon a marker
            lla: this.props.lla
        };
    }


    render() {
        return (
            <Map
                google={this.props.google}
                zoom={8}
                style={mapStyles}
                initialCenter={{
                    lat: this.props.lla[0],
                    lng: this.props.lla[1]
                }}
            >
                <Marker
                    onClick={this.onMarkerClick}
                    name={'Simulated location'}
                    draggable={true}
                    onDragend={this.moveMarker.bind(this)}
                />
                <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                    onClose={this.onClose}
                >
                    <div>
                        <h4>{this.state.selectedPlace.name}</h4>
                    </div>
                </InfoWindow>
            </Map>
        );
    }

    moveMarker = (props, marker, coord) => {
        console.log("maker dragged");
        console.log("Lat %f", coord.latLng.lat());
        console.log("Lon %f", coord.latLng.lng());
        const lla = [coord.latLng.lat(), coord.latLng.lng(), 0];
        this.setState({lla: lla});

    };

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if( prevState.lla[0] !== this.state.lla[0] && prevState.lla[1] !== this.state.lla[1]) {
            this.props.onLlaChange(this.state.lla);
        }
    };

}

export default GoogleApiWrapper({
    apiKey: C.GOOGLE_MAP_API_KEY
})(StaticScenarioMap);
